import { MosaicPreset } from '../../../services/central-api/cameras';

export const presetPositions = {
    [MosaicPreset['4_PRESET']]: [
        { x: 0, y: 0, w: 6, h: 6, minW: 2, minH: 2 },
        { x: 6, y: 0, w: 6, h: 6, minW: 2, minH: 2 },
        { x: 0, y: 6, w: 6, h: 6, minW: 2, minH: 2 },
        { x: 6, y: 6, w: 6, h: 6, minW: 2, minH: 2 },
    ],
    [MosaicPreset['8_PRESET']]: [
        { x: 0, y: 0, w: 9, h: 9, minW: 2, minH: 2, },
        { x: 9, y: 0, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 9, y: 3, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 9, y: 6, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 0, y: 9, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 3, y: 9, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 6, y: 9, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 9, y: 9, w: 3, h: 3, minW: 2, minH: 2, },
    ],
    [MosaicPreset['9_PRESET']]: [
        { x: 0, y: 0, w: 4, h: 4, minW: 2, minH: 2, },
        { x: 4, y: 0, w: 4, h: 4, minW: 2, minH: 2, },
        { x: 8, y: 0, w: 4, h: 4, minW: 2, minH: 2, },
        { x: 0, y: 4, w: 4, h: 4, minW: 2, minH: 2, },
        { x: 4, y: 4, w: 4, h: 4, minW: 2, minH: 2, },
        { x: 8, y: 4, w: 4, h: 4, minW: 2, minH: 2, },
        { x: 0, y: 8, w: 4, h: 4, minW: 2, minH: 2, },
        { x: 4, y: 8, w: 4, h: 4, minW: 2, minH: 2, },
        { x: 8, y: 8, w: 4, h: 4, minW: 2, minH: 2, },
    ],
    [MosaicPreset['10_PRESET']]: [
        { x: 0, y: 0, w: 6, h: 6, minW: 2, minH: 2, },
        { x: 6, y: 0, w: 6, h: 6, minW: 2, minH: 2, },

        { x: 0, y: 6, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 3, y: 6, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 6, y: 6, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 9, y: 6, w: 3, h: 3, minW: 2, minH: 2, },

        { x: 0, y: 9, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 3, y: 9, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 6, y: 9, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 9, y: 9, w: 3, h: 3, minW: 2, minH: 2, },
    ],
    [MosaicPreset['13_PRESET']]: [
        { x: 0, y: 0, w: 6, h: 6, minW: 2, minH: 2, },

        { x: 6, y: 0, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 9, y: 0, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 6, y: 3, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 9, y: 3, w: 3, h: 3, minW: 2, minH: 2, },

        { x: 0, y: 6, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 3, y: 6, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 6, y: 6, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 9, y: 6, w: 3, h: 3, minW: 2, minH: 2, },

        { x: 0, y: 9, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 3, y: 9, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 6, y: 9, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 9, y: 9, w: 3, h: 3, minW: 2, minH: 2, },
    ],
    [MosaicPreset['16_PRESET']]: [
        { x: 0, y: 0, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 3, y: 0, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 6, y: 0, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 9, y: 0, w: 3, h: 3, minW: 2, minH: 2, },

        { x: 0, y: 3, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 3, y: 3, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 6, y: 3, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 9, y: 3, w: 3, h: 3, minW: 2, minH: 2, },

        { x: 0, y: 6, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 3, y: 6, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 6, y: 6, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 9, y: 6, w: 3, h: 3, minW: 2, minH: 2, },

        { x: 0, y: 9, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 3, y: 9, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 6, y: 9, w: 3, h: 3, minW: 2, minH: 2, },
        { x: 9, y: 9, w: 3, h: 3, minW: 2, minH: 2, },
    ],
    [MosaicPreset['18_PRESET']]: [
        { x: 0, y: 0, w: 2, h: 3, minW: 2, minH: 2, },
        { x: 2, y: 0, w: 2, h: 3, minW: 2, minH: 2, },
        { x: 4, y: 0, w: 2, h: 3, minW: 2, minH: 2, },
        { x: 6, y: 0, w: 2, h: 3, minW: 2, minH: 2, },
        { x: 8, y: 0, w: 2, h: 3, minW: 2, minH: 2, },
        { x: 10, y: 0, w: 2, h: 3, minW: 2, minH: 2, },

        { x: 0, y: 3, w: 4, h: 3, minW: 2, minH: 2, },
        { x: 4, y: 3, w: 4, h: 3, minW: 2, minH: 2, },
        { x: 8, y: 3, w: 4, h: 3, minW: 2, minH: 2, },

        { x: 0, y: 6, w: 4, h: 3, minW: 2, minH: 2, },
        { x: 4, y: 6, w: 4, h: 3, minW: 2, minH: 2, },
        { x: 8, y: 6, w: 4, h: 3, minW: 2, minH: 2, },

        { x: 0, y: 9, w: 2, h: 3, minW: 2, minH: 2, },
        { x: 2, y: 9, w: 2, h: 3, minW: 2, minH: 2, },
        { x: 4, y: 9, w: 2, h: 3, minW: 2, minH: 2, },
        { x: 6, y: 9, w: 2, h: 3, minW: 2, minH: 2, },
        { x: 8, y: 9, w: 2, h: 3, minW: 2, minH: 2, },
        { x: 10, y: 9, w: 2, h: 3, minW: 2, minH: 2, },
    ],
    [MosaicPreset['27_PRESET']]: [
        { x: 0, y: 0, w: 4, h: 4, minW: 2, minH: 2, },
        { x: 4, y: 0, w: 4, h: 4, minW: 2, minH: 2, },
        { x: 8, y: 0, w: 4, h: 4, minW: 2, minH: 2, },

        { x: 0, y: 4, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 2, y: 4, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 4, y: 4, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 6, y: 4, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 8, y: 4, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 10, y: 4, w: 2, h: 2, minW: 2, minH: 2, },

        { x: 0, y: 6, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 2, y: 6, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 4, y: 6, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 6, y: 6, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 8, y: 6, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 10, y: 6, w: 2, h: 2, minW: 2, minH: 2, },

        { x: 0, y: 8, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 2, y: 8, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 4, y: 8, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 6, y: 8, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 8, y: 8, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 10, y: 8, w: 2, h: 2, minW: 2, minH: 2, },

        { x: 0, y: 10, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 2, y: 10, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 4, y: 10, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 6, y: 10, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 8, y: 10, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 10, y: 10, w: 2, h: 2, minW: 2, minH: 2, },
    ],
    [MosaicPreset['36_PRESET']]: [
        { x: 0, y: 0, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 2, y: 0, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 4, y: 0, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 6, y: 0, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 8, y: 0, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 10, y: 0, w: 2, h: 2, minW: 2, minH: 2, },

        { x: 0, y: 2, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 2, y: 2, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 4, y: 2, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 6, y: 2, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 8, y: 2, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 10, y: 2, w: 2, h: 2, minW: 2, minH: 2, },

        { x: 0, y: 4, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 2, y: 4, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 4, y: 4, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 6, y: 4, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 8, y: 4, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 10, y: 4, w: 2, h: 2, minW: 2, minH: 2, },

        { x: 0, y: 6, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 2, y: 6, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 4, y: 6, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 6, y: 6, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 8, y: 6, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 10, y: 6, w: 2, h: 2, minW: 2, minH: 2, },

        { x: 0, y: 8, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 2, y: 8, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 4, y: 8, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 6, y: 8, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 8, y: 8, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 10, y: 8, w: 2, h: 2, minW: 2, minH: 2, },

        { x: 0, y: 10, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 2, y: 10, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 4, y: 10, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 6, y: 10, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 8, y: 10, w: 2, h: 2, minW: 2, minH: 2, },
        { x: 10, y: 10, w: 2, h: 2, minW: 2, minH: 2, },
    ],
};
